<div class="row mt-4">
  <div class="col-4 offset-4">
    <p class="bom-icon-logo"></p>
  </div>
</div>

<div class="mx-6">
  <p>Byg og Miljø understøtter desværre ikke mobilvisning.</p>
  <p>
    Hvis du ønsker at udfylde og indsende bygge- og miljøansøgninger, bedes du gå til Byg og Miljø
    fra en computer.
  </p>
</div>
